__turbopack_context__.v({
  "art": "sportsScheduleStrip-module-scss-module__qBdT0a__art",
  "channels": "sportsScheduleStrip-module-scss-module__qBdT0a__channels",
  "dateHeading": "sportsScheduleStrip-module-scss-module__qBdT0a__dateHeading",
  "description": "sportsScheduleStrip-module-scss-module__qBdT0a__description",
  "driverChannels": "sportsScheduleStrip-module-scss-module__qBdT0a__driverChannels",
  "driverItem": "sportsScheduleStrip-module-scss-module__qBdT0a__driverItem",
  "driverList": "sportsScheduleStrip-module-scss-module__qBdT0a__driverList",
  "driverPanel": "sportsScheduleStrip-module-scss-module__qBdT0a__driverPanel",
  "driverTitle": "sportsScheduleStrip-module-scss-module__qBdT0a__driverTitle",
  "entities": "sportsScheduleStrip-module-scss-module__qBdT0a__entities",
  "entity": "sportsScheduleStrip-module-scss-module__qBdT0a__entity",
  "entityContent": "sportsScheduleStrip-module-scss-module__qBdT0a__entityContent",
  "event": "sportsScheduleStrip-module-scss-module__qBdT0a__event",
  "group": "sportsScheduleStrip-module-scss-module__qBdT0a__group",
  "listenAction": "sportsScheduleStrip-module-scss-module__qBdT0a__listenAction",
  "live": "sportsScheduleStrip-module-scss-module__qBdT0a__live",
  "liveIndicator": "sportsScheduleStrip-module-scss-module__qBdT0a__liveIndicator",
  "matchup": "sportsScheduleStrip-module-scss-module__qBdT0a__matchup",
  "metadata": "sportsScheduleStrip-module-scss-module__qBdT0a__metadata",
  "name": "sportsScheduleStrip-module-scss-module__qBdT0a__name",
  "nameLink": "sportsScheduleStrip-module-scss-module__qBdT0a__nameLink",
  "row": "sportsScheduleStrip-module-scss-module__qBdT0a__row",
  "startTime": "sportsScheduleStrip-module-scss-module__qBdT0a__startTime",
  "strip": "sportsScheduleStrip-module-scss-module__qBdT0a__strip",
  "strips": "sportsScheduleStrip-module-scss-module__qBdT0a__strips",
  "time": "sportsScheduleStrip-module-scss-module__qBdT0a__time",
  "titles": "sportsScheduleStrip-module-scss-module__qBdT0a__titles",
});
